var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("img", {
        staticClass: "loading-gif",
        attrs: { src: require("../../assets/images/loading.gif") }
      }),
      _c("span", { staticClass: "time-tip" }, [_vm._v("开户审核中，请稍后...")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }